module.exports = __webpack_public_path__ + "static/media/sp.deccd62b.jpg";